import Feature35 from './Feature35'
export default Feature35
